import styled from 'styled-components';
import { color } from 'styles/pallete';

export const colorContainer = styled.label`
	cursor: pointer;
	position: relative;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: column;
	gap: 0.5rem;

	> p {
		width: 100%;
		font-size: 1.4rem;
		font-weight: 700;
		text-align: left;
		color: ${color.interface.lightGray};
	}

	> input {
		display: none;
	}
`;

export const inputBox = styled.div`
	width: 100%;
	min-height: 42px;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 0.8rem;
	border-radius: 5px;
	padding: 0.8rem 1rem;
	border: 1px solid ${color.interface.lightGray2};
	position: relative;

	> p {
		color: ${color.interface.lightGray};
		flex: 1;
		font-size: 1.3rem;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const clearBtn = styled.button`
	all: unset;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	color: ${color.interface.lightGray};
	padding: 2px;
	border-radius: 50%;
	transition: all 0.2s ease;

	&:hover {
		color: ${color.system.error};
		background-color: ${color.interface.lightGray4};
	}
`;

export const colorSquare = styled.div<{ $hexadecimalColor?: string }>`
	cursor: pointer;
	border-radius: 5px;
	width: 20px;
	min-height: 20px;
	background-color: ${(props) =>
		props.$hexadecimalColor ? `${props.$hexadecimalColor}` : 'transparent'};
	border: ${(props) =>
		props.$hexadecimalColor
			? `1px solid ${color.interface.lightGray3}`
			: `1px dashed ${color.interface.lightGray}`};
	-webkit-box-shadow: ${(props) =>
		props.$hexadecimalColor ? '0px 0px 19px -7px #000000' : 'none'};
	box-shadow: ${(props) =>
		props.$hexadecimalColor ? '0px 0px 19px -7px #000000' : 'none'};
`;

export const colorDiv = styled.div<{
	$position: string;
	$top: string | number;
	$left: string | number;
	$right: string | number;
	$bottom: string | number;
}>`
	position: ${(props) => props.$position};
	min-width: fit-content;
	max-width: fit-content;
	background-color: ${color.interface.white};
	border: 1px solid ${color.interface.lightGray};
	top: ${(props) => props.$top};
	left: ${(props) => props.$left};
	right: ${(props) => props.$right};
	bottom: ${(props) => props.$bottom};
	z-index: 100000;
	border: none;
	display: flex;
	flex-direction: column;
	border-radius: 5px;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
	overflow: hidden;
`;

export const btns = styled.div`
	width: 100%;
	display: flex;
	gap: 0.5rem;
	align-items: center;
	justify-content: center;
	padding: 0.8rem;
	background-color: ${color.interface.white};

	> button {
		all: unset;
		border-radius: 5px;
		width: 100%;
		padding: 0.8rem;
		text-align: center;
		font-size: 1.2rem;
		font-weight: 600;
		cursor: pointer;
	}
`;

export const confirmBtn = styled.button`
	background-color: ${color.system.info} !important;
	color: ${color.interface.white} !important;
`;

export const clearModalBtn = styled.button`
	background-color: ${color.system.error} !important;
	color: ${color.interface.white} !important;
`;
